export interface WorkItem {
  id: number,
  revision: number,
  type: string,
  title: string,
  boardColumn: string,
  priority: number,
  state: string,
  createdDate: number,
  description: string,
  totalComments: number,
  url: string,
  createdBy: {
    displayName: string,
    avatar: string
  }
}
